"use client";

// src/checkbox/checkbox-checked-context.tsx
import { createContext } from "react";
var CheckboxCheckedContext = createContext(false);

export {
  CheckboxCheckedContext
};
